function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { cloneDeep, get } from 'lodash';
var surface = {
  default: '1px solid neutral.light',
  empty: '1px solid neutral.lighter',
  transparent: '1px solid transparent'
};
var basic = {
  critical: '1px solid critical.main',
  success: '1px solid success.main',
  warning: '1px solid warning.main',
  info: '1px solid info.main',
  brand: '1px solid brand.main',
  black: '1px solid neutral.black',
  dark: '1px solid neutral.dark',
  darker: '1px solid neutral.darker',
  darkest: '1px solid neutral.darkest',
  light: '1px solid neutral.light',
  lighter: '1px solid neutral.lighter',
  white: '1px solid neutral.white'
};
var selection = {
  selectedBrand: '2px solid brand.main',
  selectedNeutral: '2px solid neutral.black',
  disabled: '2px solid neutral.light',
  transparent: '2px solid transparent'
};
var input = {
  enabled: '1px solid neutral.light',
  hover: '1px solid neutral.dark',
  readOnly: '1px solid neutral.light',
  disabled: '1px solid neutral.light',
  error: '1px solid critical.main',
  brand: '1px solid brand.main',
  transparent: '1px solid transparent'
};
var inputThick = {
  enabled: '2px solid neutral.dark',
  focused: '2px solid neutral.black',
  hover: '2px solid neutral.darkest',
  readOnly: '2px solid neutral.darker',
  disabled: '2px solid neutral.light',
  error: '2px solid critical.main',
  brand: '2px solid brand.main',
  transparent: '2px solid transparent'
};
var textArea = {
  enabled: '1px solid neutral.light',
  hover: '1px solid neutral.dark',
  readOnly: '1px solid neutral.lighter',
  disabled: '1px solid neutral.light',
  error: '1px solid critical.main',
  brand: '1px solid brand.main'
};
var inputDashed = {
  enabled: '1px dashed neutral.dark',
  focused: '1px dashed neutral.black',
  hover: '1px dashed neutral.darkest',
  readOnly: '1px dashed neutral.darker',
  disabled: '1px dashed neutral.light',
  error: '1px dashed critical.main',
  transparent: '1px dashed transparent'
};
var inputDashedThick = {
  enabled: '2px dashed neutral.dark',
  focused: '2px dashed neutral.black',
  hover: '2px dashed neutral.darkest',
  readOnly: '2px dashed neutral.darker',
  disabled: '2px dashed neutral.light',
  error: '2px dashed critical.main',
  transparent: '2px dashed transparent'
};
var defaultBorders = {
  surface,
  basic,
  selection,
  input,
  'input-thick': inputThick,
  'text-area': textArea,
  'input-dashed': inputDashed,
  'input-dashed-thick': inputDashedThick
};
export var getBorders = colors => {
  var borders = cloneDeep(defaultBorders);
  Object.values(borders).forEach(borderType => {
    Object.entries(borderType).forEach(_ref => {
      var [key, value] = _ref;
      var [borderWidth, borderStyle, borderColor] = value.split(' ');
      borderType[key] = "".concat(borderWidth, " ").concat(borderStyle, " ").concat(get(colors, borderColor, 'transparent'));
    });
  });
  return _objectSpread({
    none: 0
  }, borders);
};
//# sourceMappingURL=borders.js.map